"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = require("classnames");
var React = require("react");
var react_dom_1 = require("react-dom");
var Portal_1 = require("../base/Portal");
var utils_1 = require("../utils");
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDocumentMouseMove = function () {
            _this.positionTooltip();
        };
        _this.positionTooltip = function ($el) {
            var _a = _this.props, position = _a.position, children = _a.children;
            $el = $el || react_dom_1.findDOMNode(_this.childRef);
            if (!$el) {
                return;
            }
            _this.frame = utils_1.raf(function () {
                var width = $el.offsetWidth;
                var height = $el.offsetHeight;
                var rect = $el.getBoundingClientRect();
                var top = rect.top + window.pageYOffset;
                var left = rect.left + window.pageXOffset;
                switch (position) {
                    case "right":
                        left += width;
                        top += height / 2;
                        break;
                    case "bottom":
                        top += height;
                        left += width / 2;
                        break;
                    case "top":
                        left += width / 2;
                        break;
                    case "left":
                        top += height / 2;
                        break;
                }
                _this.setState({ top: top, left: left });
            });
        };
        _this.onMouseEnter = function (e) {
            var _a = _this.props, children = _a.children, delay = _a.delay;
            _this.cancelDelayedTooltip();
            _this.childRef = e.currentTarget;
            children.props.onMouseEnter && children.props.onMouseEnter(e);
            var $el = e.currentTarget;
            _this.delayTimeout = setTimeout(function () {
                _this.positionTooltip($el);
                _this.setState({ show: true });
            }, delay);
        };
        _this.onMouseLeave = function (e) {
            var children = _this.props.children;
            utils_1.caf(_this.frame);
            _this.cancelDelayedTooltip();
            children.props.onMouseLeave && children.props.onMouseLeave(e);
            if (_this.state.show) {
                _this.setState({ show: false });
            }
        };
        _this.onMouseDown = function (e) {
            var children = _this.props.children;
            children.props.onMouseDown && children.props.onMouseDown(e);
            _this.subscribeToDocumentEvents();
        };
        _this.onMouseUp = function (e) {
            var children = _this.props.children;
            children.props.onMouseUp && children.props.onMouseUp(e);
            _this.unsubscribeFromDocumentEvents();
        };
        _this.setTooltipRef = function (el) {
            _this.tooltipRef = el;
        };
        _this.onTooltipMouseEnter = function () {
            _this.setState({ mouseOverTooltip: true });
        };
        _this.onTooltipMouseLeave = function () {
            _this.setState({ mouseOverTooltip: false });
        };
        _this.childRef = _this.tooltipRef = null;
        _this.state = { show: false, top: 0, left: 0, mouseOverTooltip: false };
        return _this;
    }
    Tooltip.prototype.componentWillUnmount = function () {
        this.cancelDelayedTooltip();
        this.unsubscribeFromDocumentEvents();
        this.childRef = null;
    };
    Tooltip.prototype.subscribeToDocumentEvents = function () {
        utils_1.addEventsToDocument(this.getMouseEventMap());
    };
    Tooltip.prototype.unsubscribeFromDocumentEvents = function () {
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
    };
    Tooltip.prototype.getMouseEventMap = function () {
        return {
            mousemove: this.onDocumentMouseMove
        };
    };
    Tooltip.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.show || this.props.show) {
            this.positionTooltip();
        }
    };
    Tooltip.prototype.cancelDelayedTooltip = function () {
        clearTimeout(this.delayTimeout);
    };
    Tooltip.prototype.createTooltip = function () {
        if ((!this.state.show && !this.state.mouseOverTooltip && !this.props.show) || !this.props.title) {
            return null;
        }
        var _a = this.props, children = _a.children, className = _a.className, theme = _a.theme, title = _a.title, position = _a.position, delay = _a.delay, leaveOpenOnMouseOver = _a.leaveOpenOnMouseOver, others = tslib_1.__rest(_a, ["children", "className", "theme", "title", "position", "delay", "leaveOpenOnMouseOver"]);
        var classes = classnames_1.default(theme.tooltip, className, theme[position]);
        var _b = this.state, top = _b.top, left = _b.left;
        var props = {};
        if (leaveOpenOnMouseOver) {
            props.onMouseEnter = this.onTooltipMouseEnter;
            props.onMouseLeave = this.onTooltipMouseLeave;
        }
        return (React.createElement(Portal_1.default, { key: "tooltip" },
            React.createElement("div", tslib_1.__assign({ className: classes, style: { top: top, left: left }, ref: this.setTooltipRef }, props),
                React.createElement("div", { className: theme.inner },
                    React.createElement("div", { className: theme.label }, title)))));
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, disabled = _a.disabled, title = _a.title, delay = _a.delay, position = _a.position, theme = _a.theme, leaveOpenOnMouseOver = _a.leaveOpenOnMouseOver, others = tslib_1.__rest(_a, ["children", "disabled", "title", "delay", "position", "theme", "leaveOpenOnMouseOver"]);
        return [
            React.cloneElement(React.Children.only(children), {
                key: children.key || "child",
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp
            }),
            disabled ? null : this.createTooltip()
        ];
    };
    Tooltip.defaultProps = {
        delay: 0,
        position: "top",
        show: false
    };
    return Tooltip;
}(React.PureComponent));
exports.default = Tooltip;
